var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundFiremin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1317,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M654.839 302.095C568.648 219.257 501.798 116.499 461.658 1.216H-8.486c66 113.313 103.852 245.062 103.852 385.663 0 345.777-228.723 638.091-543.149 734.111v194.82H572.492c-96.311-128.25-153.382-287.63-153.382-460.356 0-217.408 90.448-413.681 235.729-553.334v-.025z",
    fill: "url(#prefix__paint0_linear_2197_37278)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M654.838 302.095c137.983-132.624 325.423-214.15 531.932-214.15 206.52 0 393.95 81.55 531.94 214.15 70.62-67.881 128.27-149.138 168.9-239.687V1.217H461.658c40.139 115.283 107.014 218.065 193.18 300.879z",
    fill: "url(#prefix__paint1_linear_2197_37278)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M95.366 386.879c0-140.601-37.853-272.326-103.852-385.663h-439.297V1120.97c314.426-96 543.149-388.339 543.149-734.115v.024z",
    fill: "url(#prefix__paint2_linear_2197_37278)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1718.71 302.095c-137.99 132.624-325.42 214.15-531.94 214.15-206.509 0-393.949-81.55-531.931-214.15C509.533 441.748 419.11 638.022 419.11 855.43c0 172.71 57.071 332.08 153.382 460.35H1801.08a766.205 766.205 0 0086.53-146.7V541.806c-40.6-90.572-98.28-171.806-168.9-239.686v-.025z",
    fill: "url(#prefix__paint3_linear_2197_37278)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M654.839 302.095c137.982 132.624 325.422 214.15 531.931 214.15 206.52 0 393.96-81.55 531.94-214.15-137.98-132.624-325.42-214.15-531.94-214.15-206.509 0-393.949 81.55-531.931 214.15z",
    fill: "url(#prefix__paint4_linear_2197_37278)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear_2197_37278",
    x1: 1211.51,
    y1: 1168.91,
    x2: -978.227,
    y2: 44.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#EF614C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear_2197_37278",
    x1: 461.368,
    y1: 302.242,
    x2: 2554,
    y2: 302.242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#EF614C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear_2197_37278",
    x1: -1201.57,
    y1: 501.31,
    x2: 337.559,
    y2: 501.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#EF614C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear_2197_37278",
    x1: 1177.53,
    y1: 1768.54,
    x2: 1192.09,
    y2: 127.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#EF614C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint4_linear_2197_37278",
    x1: 891.063,
    y1: 571.712,
    x2: 1284.34,
    y2: -277.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.099,
    stopColor: "#FC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.901,
    stopColor: "#EF614C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundFiremin);
export default __webpack_public_path__ + "static/media/background-fire.min.19b9482bb9d6a5d3b16079988caba07e.svg";
export { ForwardRef as ReactComponent };